export const getMealDealProgressMessage = (
  productCountAndTotal: { totalCount: number; productCount: number } | null,
): string | null =>
  productCountAndTotal
    ? `${productCountAndTotal.productCount} of ${productCountAndTotal.totalCount} added`
    : null;
